module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor15-32513c2d6399c51b58723a47a6d1d1f3.png";